export const generateOrderNumber = (date: string)=> {
    const getDate = new Date(date);
    return `${getDate.getDate()}${getDate.getMonth()}${getDate.getFullYear()}${getDate.getHours()}${getDate.getMinutes()}${getDate.getSeconds()}`
}